/* eslint-disable unused-imports/no-unused-vars */
import { Box, ToggleButton, ToggleButtonGroup, Tooltip, styled, toggleButtonGroupClasses } from "@mui/material";
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import Typography from '@/components/typography/typography';

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme, item }) => ({
  display: 'grid',
  borderRadius: 4,
  border: `1px solid #e3e3e3`,
  width: `100%`,
  gridTemplateColumns: `repeat(${item || 4}, 1fr)`,
  [`& .${toggleButtonGroupClasses.grouped}`]: {
    margin: theme.spacing(0.5),
    border: 0,
    borderRadius: theme.shape.borderRadius,
    [`&.${toggleButtonGroupClasses.disabled}`]: {
      border: 0,
    },
  },
  [`& .${toggleButtonGroupClasses.middleButton},& .${toggleButtonGroupClasses.lastButton}`]:
  {
    marginLeft: -1,
    borderLeft: '1px solid transparent',
  },
  [`& .${toggleButtonGroupClasses.selected}`]: {
    backgroundColor: `${theme.palette.action.selected} !important`,
    color: `${theme.palette.text.primary} !important`,
  }
}))

interface AlignmentControlProps {
  alignment: string;
  onAlignmentChange: (event: React.MouseEvent<HTMLElement>, newAlignment: string | null) => void;
  displayLabel?: boolean;
}

const AlignmentControl: React.FC<AlignmentControlProps> = ({
  alignment,
  onAlignmentChange,
  displayLabel = false,
  // disableJustify = false
}) => {
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
      {displayLabel &&
        <Typography type="s5" weight="medium" color={"theme.secondary.800"}>Alignment</Typography>
      }
      <StyledToggleButtonGroup
        value={alignment}
        exclusive
        onChange={onAlignmentChange}
        aria-label="text alignment"
        size="small"
      >
        <Tooltip title="Align Left">
          <ToggleButton value="left" aria-label="left aligned">
            <FormatAlignLeftIcon fontSize="small" />
          </ToggleButton>
        </Tooltip>
        <Tooltip title="Align Center">
          <ToggleButton value="center" aria-label="centered">
            <FormatAlignCenterIcon fontSize="small" />
          </ToggleButton>
        </Tooltip>
        <Tooltip title="Align Right">
          <ToggleButton value="right" aria-label="right aligned">
            <FormatAlignRightIcon fontSize="small" />
          </ToggleButton>
        </Tooltip>
        {/* {!disableJustify && */}
        <Tooltip title="Justify">
          <ToggleButton value="justify" aria-label="justified">
            <FormatAlignJustifyIcon fontSize="small" />
          </ToggleButton>
        </Tooltip>
        {/* } */}
      </StyledToggleButtonGroup>
    </Box>
  );
}

export default AlignmentControl;